import { Directive, ElementRef, Input, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[zoomImage]'
})
export class ZoomImageDirective {
  @Input('zoomImage') zoomSrc: string = '';

  private zoomContainer!: HTMLDivElement;
  private zoomedImage!: HTMLImageElement;
  private zoomFactor = 6; // Scale of zoom
  private zoomContainerSize = 200; // Size of the zoom box

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter', ['$event']) onMouseEnter(event: MouseEvent) {
    this.createZoom(event);
  }

  @HostListener('mousemove', ['$event']) onMouseMove(event: MouseEvent) {
    this.moveZoom(event);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.removeZoom();
  }

  private createZoom(event: MouseEvent) {
    this.removeZoom(); // Ensure no duplicate zoom container exists

    const rect = this.el.nativeElement.getBoundingClientRect();

    // Create zoom container
    this.zoomContainer = this.renderer.createElement('div');
    this.renderer.setStyle(this.zoomContainer, 'position', 'absolute');
    this.renderer.setStyle(this.zoomContainer, 'width', `${this.zoomContainerSize}px`);
    this.renderer.setStyle(this.zoomContainer, 'height', `${this.zoomContainerSize}px`);
    this.renderer.setStyle(this.zoomContainer, 'overflow', 'hidden');
    this.renderer.setStyle(this.zoomContainer, 'border', '1px solid #ddd');
    this.renderer.setStyle(this.zoomContainer, 'background', '#fff');
    this.renderer.setStyle(this.zoomContainer, 'pointer-events', 'none'); // Prevents interference
    this.renderer.setStyle(this.zoomContainer, 'z-index', '1000');

    // Position near cursor
    this.renderer.setStyle(this.zoomContainer, 'top', `${event.clientY + 10}px`);
    this.renderer.setStyle(this.zoomContainer, 'left', `${event.clientX + 10}px`);

    // Create zoomed image
    this.zoomedImage = this.renderer.createElement('img');
    this.renderer.setAttribute(this.zoomedImage, 'src', this.zoomSrc);
    this.renderer.setStyle(this.zoomedImage, 'position', 'absolute');
    this.renderer.setStyle(this.zoomedImage, 'width', `${rect.width * this.zoomFactor}px`);
    this.renderer.setStyle(this.zoomedImage, 'height', `${rect.height * this.zoomFactor}px`);

    // Append elements
    this.renderer.appendChild(this.zoomContainer, this.zoomedImage);
    this.renderer.appendChild(document.body, this.zoomContainer);
  }

  private moveZoom(event: MouseEvent) {
    if (!this.zoomContainer || !this.zoomedImage) return;

    const rect = this.el.nativeElement.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const offsetY = event.clientY - rect.top;

    // Move zoom box to follow cursor
    this.renderer.setStyle(this.zoomContainer, 'top', `${event.clientY + 10}px`);
    this.renderer.setStyle(this.zoomContainer, 'left', `${event.clientX + 10}px`);

    // Adjust zoomed image position for correct focus
    const imageMoveX = -offsetX * this.zoomFactor + this.zoomContainerSize / 2;
    const imageMoveY = -offsetY * this.zoomFactor + this.zoomContainerSize / 2;

    this.renderer.setStyle(this.zoomedImage, 'left', `${imageMoveX}px`);
    this.renderer.setStyle(this.zoomedImage, 'top', `${imageMoveY}px`);
  }

  private removeZoom() {
    if (this.zoomContainer && this.zoomContainer.parentNode) {
      this.zoomContainer.parentNode.removeChild(this.zoomContainer);
    }
  }
}
